export default __webpack_public_path__ + "static/media/cloud2.1d2b6a17.png";